<template>
  <div class="app-prices">
    <div v-if="showOld" class="price old">
      <template v-if="isRange(oldRange)">
        <small v-if="showMaxPrice === false">a partir de</small>

        <AppPrice
          v-model="oldRange.min"
          v-bind="{
            smallCase,
            showSign,
          }"
          striped
          small
        />

        <template v-if="showMaxPrice">
          -
          <AppPrice
            v-model="oldRange.max"
            v-bind="{
              smallCase,
              showSign,
            }"
            striped
            small
          />
        </template>
      </template>

      <AppPrice
        v-else
        :value="oldRange.max"
        v-bind="{
          smallCase,
          showSign,
        }"
        striped
        small
      />
    </div>

    <div v-if="isRange(range)" class="price current">
      <small v-if="showMaxPrice === false">a partir de</small>

      <AppPrice
        v-model="range.min"
        v-bind="{
          smallCase,
          showSign,
        }"
      />
      <template v-if="showMaxPrice">
        -
        <AppPrice
          v-model="range.max"
          v-bind="{
            smallCase,
            showSign,
          }"
        />
      </template>
    </div>

    <AppPrice
      v-else
      :value="range.max"
      class="current"
      v-bind="{
        smallCase,
        showSign,
      }"
    />
  </div>
</template>

<script>
import AppPrice from '@/components/App/Price.vue'

export default {
  name: 'AppPrices',

  components: {
    AppPrice,
  },

  props: {
    value: {
      type: String | Number | Object | Array,
      required: true,
    },

    oldValue: {
      type: String | Number | Object | Array,
      required: false,
    },

    showSign: {
      type: Boolean,
      default: false,
    },

    smallCase: {
      type: Boolean,
      default: false,
    },

    showOldWhenSmall: {
      type: Boolean,
      default: false,
    },

    showMaxPrice: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    range() {
      return this.getRange(this.value)
    },

    oldRange() {
      return this.getRange(this.oldValue)
    },

    showOld() {
      const { showOldWhenSmall = false, oldRange, range } = this

      return (
        (oldRange.min !== Infinity &&
          range.min !== Infinity &&
          (oldRange.min > range.min ||
            (oldRange.min !== range.min && showOldWhenSmall))) ||
        (oldRange.max !== Infinity &&
          range.max !== Infinity &&
          (oldRange.max > range.max ||
            (oldRange.max !== range.max && showOldWhenSmall)))
      )
    },
  },

  methods: {
    getRange(value) {
      let min = value?.min ?? value
      let max = value?.max ?? value

      if (Array.isArray(value)) {
        min = Math.min(...value)
        max = Math.max(...value)
      }

      return { min, max }
    },

    isRange({ min, max }) {
      return min !== max
    },
  },
}
</script>

<style lang="scss" scoped>
.app-prices {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;

  &.text-left {
    text-align: left;
    align-items: flex-start;
  }

  > .price {
    display: flex;
    align-items: baseline;
    gap: 0.15em;

    small {
      font-size: 65%;
    }
  }
}
</style>
